import { Component, Input, OnInit } from '@angular/core';

import { UntilDestroy } from '@contact/upgrade';

import { ResponseModel, ResponseModelAttachment } from '../../models/responseModel';
import { LinkTypeEnumeration } from '../models/responseModel';
import { KnowledgeBaseOwiService } from '../services/knowledge-base-OWI.service';

interface Attachment {
  name: string;
  url: string;
}

@UntilDestroy()
@Component({
  selector: 'knowledge-base-attachment',
  templateUrl: 'knowledge-base-attachment.component.html',
  styleUrls: ['./knowledge-base-attachment.component.scss'],
})
export class KnowledgeBaseAttachmentComponent implements OnInit {
  @Input() readonly currentDocument: ResponseModel;
  readonly LinkTypeEnumeration = LinkTypeEnumeration;
  linkUrl: string;
  attachments: Attachment[];

  constructor(private readonly knowledgeBaseOwiService: KnowledgeBaseOwiService) {}

  ngOnInit(): void {
    this.linkUrl = this.knowledgeBaseOwiService.getFileUrlByPath(this.currentDocument.link);
    this.attachments = this.currentDocument.attachments.map(attachment => ({
      name: attachment.name,
      url: this.knowledgeBaseOwiService.getFileUrlByResponseModelIdAndFileName(attachment.responseModelId, attachment.name),
    }));
  }
}
